import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useAcceptDeclineDepositLimits = () => {
    const send = useGenericSend();

    return useCallback(async ({ action, timePeriods }: Types.IAcceptDepositLimitsRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.IAcceptDepositLimitsRequestData, TServerSendResponse>({
            ID: 89902,
            description: 'Accept Player Deposit Limits',
            responses: [89906, 89900],
            action,
            timePeriods
        });

        return data;
    }, [
        send
    ]);
};
